<template>
  <div class="timePicker">
    <flat-pickr
      id="timeInput"
      v-model="localSelectedTime"
      :config="flatpickrConfig"
      :disabled="disabled"
      @change="updateTime"
    >
    </flat-pickr>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';

import VueFlatpickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { InputFileEvent } from '@/types';

@Options({
  name: 'TimePicker',
  props: ['selectedTime', 'disabled'],
  components: {
    flatPickr: VueFlatpickr
  },
  data() {
    return {
      localSelectedTime: this.selectedTime || '',
      flatpickrConfig: {
        enableTime: true,
        noCalendar: true,
        dateFormat: 'H:i',
        time_24hr: true
      }
    };
  },
  methods: {
    updateTime(event: InputFileEvent) {
      this.$emit('updateTime', event);
    }
  },
  watch: {
    selectedTime(newVal: string) {
      this.localSelectedTime = newVal;
    }
  }
})
export default class TimePicker extends Vue {}
</script>

<style lang="scss">
.timePicker {
  position: relative;
  width: 148px;
  height: 36px;
  .flatpickr-input {
    height: 100%;
    position: relative;
    box-sizing: content-box;
    border-radius: 3px;
    padding-left: 10px;
    border: 1px solid #dadada;
  }
  img {
    position: absolute;
    top: 13px;
    right: 11px;
  }
}

.disabledInput {
  background-color: $timePicker;
  .flatpickr-input {
    background-color: $timePicker;
  }
  .img {
    background-color: $timePicker;
  }
}

.flatpickr-time {
  border-top: none;
  border-radius: 6px !important;
}
</style>
